module.exports = __webpack_public_path__ + "assets/img/btn-download-steam-cb905428.png";